import axios from './../../../node_modules/axios/index';
import qs from 'qs';
import { reportError } from '@/utils/monitor.js'

const getCurrentEnv = () => {
    const ua = navigator.userAgent.toLowerCase();
    if (/bestpay/gi.test(ua) || /orange/gi.test(ua)) { // 甜橙和翼支付环境
        return 'tc'
    } else if (/micromessenger/gi.test(ua)) { // 微信环境
        return 'wechat'
    } else if (/xiaomi/gi.test(ua)) { //小米环境
        return 'xiaomi'
    } else if (/maijinwang/gi.test(ua)) { // 买金网
        return 'maijin'
    } else {
        return _.urlInfo.sys
    }
};

const hostname = location.hostname;
export const config = {
    download: {
        ths: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.hexin.plat.android',
        ijijin: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.hexin.android.bank'
    },
    isSharePage: !!_.fn.getUrlParam('share'),
    pageId: 'fund_mkt_20210517_index',
    urlVer: 'FW-1045',
    openMock: !!_.fn.getUrlParam('openMock'),
    prefix: hostname === 'trade.5ifund.com' ? 'tohangqing' : '',
    localDev: hostname == 'localhost',
    testDev: hostname === 'localhost' || !!_.urlInfo.test,
    env: getCurrentEnv()
}


/**
 * 添加0
 */
export function addZero(number) {
    if (number < 10) {
        return `0${number}`
    } else {
        return number
    }
}

/**
 * 获取时间格式
 */
export function getTimeStr(_startDate, _endDate) {
    let _month = addZero(parseInt(_startDate.getMonth()) + 1), //月份
    _date = addZero(_startDate.getDate()), //日期
    _startHour = addZero(_startDate.getHours()), //起始小时
    _startMinute = addZero(_startDate.getMinutes()), //起始分钟
    _endHour = addZero(_endDate.getHours()), //结束小时
    _endMinute = addZero(_endDate.getMinutes()) //结束分钟
    
    return `${_month}月${_date}日 ${_startHour}:${_startMinute}-${_endHour}:${_endMinute}`
}

export function getTimeDate(val = '') {
    let date = new Date();
    if (val) {
        date = new Date(val);
    }
    let _month = addZero(parseInt(date.getMonth()) + 1), //月份
    _date = addZero(date.getDate()), //日期
    _year = date.getFullYear();
    return `${_year}-${_month}-${_date}`;
}
/**
* @description axios 请求方法的封装
* @param {String} url 
*/
export const get = (url, dataToSend = {}) => {
    const mockUrl = config.openMock
  ? `https://testfund.10jqka.com.cn/ifundtools/mock/entry/${config.urlVer}`
  : '';
    return new Promise(((resolve, reject) => {
        axios.get(`${mockUrl}${url}`, {params: dataToSend})
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reportError('ajax', `error get url=${url}`, error);
                reject(error);
            });
    }));
};

export const post = (url, dataToSend = {}) => {
    const mockUrl = config.openMock
  ? `https://testfund.10jqka.com.cn/ifundtools/mock/entry/${config.urlVer}`
  : '';
    return new Promise(((resolve, reject) => {
        let options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(dataToSend),
            url: `${mockUrl}${url}`,
        }
        axios(options).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reportError('ajax', `error post url=${url}`, error);
            reject(error);
        });
    }));
};

export const postJson = (url, dataToSend = {}) => {
    return new Promise(((resolve, reject) => {
        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            data: dataToSend,
            url,
        }
        axios(options).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reportError('ajax', `error post url=${url}`, error);
            reject(error);
        });
    }));
};

/**
 * 修改文本
 */
export function handleTxt (text, len) {
    if (!text) {
        return '--'
    } else if(text) {
        if (text.length > len) {
            return `${text.slice(0, len - 1)}...`;
        } else {
            return text;
        }
    }
}
/**
 * 修改利率
 */
export function handleRate (rate) {
    if (!rate && rate != 0) {
        return '--'
    } else if (rate) {
        if (parseFloat(rate) > 0) {
            return `+${parseFloat(rate).toFixed(2)}%`;
        } else {
            return `${parseFloat(rate).toFixed(2)}%`;
        }
    }
}

/**
 * 倒计时时间
 */
export function handleNumber(number) {
    if (number < 10) {
        return `0${number}`
    } else {
        return number
    }
}

export let initStat = () => {
    _.statSet({
        pageid: config.pageId,
        url_ver: config.urlVer,
        bottom: false
    });
}

/**
 * 检查登录
 * @param fn1 登录的回调
 * @param fn2 未登录的回调
 */
export let isLogin = (fn1, fn2) => {
    if (window.location.hostname === 'localhost') {
        _.urlInfo.sys = 'ths';
        window.getUserid = function () {
            return '602563878'
        };
        let custId = 100110015537;
        window.userinfo = {
            custId: custId,
            encryptionCustId: custId * 59 + 101
        };
        return fn1 && fn1()
    }
    if (_.urlInfo.sys === 'ths') {
        isLogin = (fn1, fn2) => {
            if (getAccount() === 0) {
                if (fn2 && fn2() === false) {
                    return;
                }
                let timer = setInterval(function () {
                    //手炒登录以后刷新页面
                    if (getAccount() !== 0) {
                        clearInterval(timer);
                        window.location.reload();
                    }
                }, 500);
                window.location.href = "http://eqhexin/changeUser";
            } else {
                fn1 && fn1();
            }
        };
        isLogin(fn1, fn2);
    } else {
        isLogin = (fn1, fn2) => {
            if (fn2) {
                _.getUserinfo(() => {
                    fn1 && fn1();
                }, () => {
                    fn2 && fn2();
                });
            } else {
                _.getUserinfo(() => {
                    fn1 && fn1();
                });
            }
        };
        isLogin(fn1, fn2);
    }
};

/**
 * 判断是否是sdk环境
 * @return boolean
 */
export const isSdk = () => {
    let _ua = navigator.userAgent.toLowerCase();
    if (_ua.match(/IJiJinSDK/i) == "ijijinsdk") {
        return true;
    } else {
        return false;
    }
}
export const isAndroid = () => {
    return _.platform.osInfo === 'gphone';
}

/**
 * 跳转手炒个股页面
 */
export const goStockPage = (stockcode, marketid) => {
    if (_.urlInfo.sys === 'ths') {
      location.href = `client.html?action=ymtz^webid=2205^stockcode=${stockcode}^marketid=${marketid}`;
    } else if (_.urlInfo.sys === 'ijijin') {
      if (isSdk()) {
        _.ijijinVerControl('6.02.01', function () {
          alert('当前版本过低，本功能无法使用，请更新客户端版本');
        }, function () {
          if (_.platform.osInfo === 'iphone') {
            callNativeHandler("jumpToShouChao", {
              "iOSJumpHeXinUrl": `command=gotoHQ&action=GGFS&stockcode=${stockcode}&appName=爱基金&version=1&donotSwitchStackTab=1`
            }, function () {
            });
          } else {
            location.href = `client.html?action=jumpToHeXinGG,stockCode=${stockcode},marketId=${marketid}`;
          }
        });
      } else {
        // app
        if (_.platform.osInfo === 'iphone') {
            console.log('app ios');
          _.ijijinVerControl('6.05.01', function () {
            alert('当前版本过低，本功能无法使用，请更新客户端版本');
          }, function () {
            callNativeHandler("jumpToShouChao", {
              "code": stockcode,
              "market": marketid
            }, function () {
            });
          });
        } else {
            console.log('app adr');
          _.ijijinVerControl('6.02.01', function () {
            alert('当前版本过低，本功能无法使用，请更新客户端版本');
          }, function () {
            location.href = `client.html?action=jumpToHeXinGG,stockCode=${stockcode},marketId=${marketid}`;
          });
        }
      }
    }
  }

export const toBind = (url) => {
    let setcookie = function setcookie(name, value, expires, path, domain, secure = '') {
        if (!name) {
            return false;
        }
        expires = expires ? '; expires=' + new Date(expires * 10000).toUTCString() : "";
        document.cookie = name + "=" + escape(value) + expires + (path ? "; path=" + path : "") + (domain ? "; domain=" + domain : "") + (secure ? "; secure" : "");
    };
    let newBind = function newBind(url) {
        const DATA = {
            bind: "//ozone.10jqka.com.cn/tg_templates/doubleone/2018/fundBind/index.html",
            register: "//ozone.10jqka.com.cn/tg_templates/doubleone/2018/newJijinKaihu/bindCard.html"
        };
        if (location.host.indexOf('test') > -1) {
            // 测试环境
            DATA.bind = "//testm.10jqka.com.cn/tg_templates/doubleone/2018/fundBind/index.html";
            DATA.register = "//testm.10jqka.com.cn/tg_templates/doubleone/2017/newJijinKaihu/bindCard.html";
        }
        // 存标识
        setcookie("pushbackUrl", url, 1576800000, '/', '10jqka.com.cn');
        setcookie("from", "push", 1576800000, '/', '10jqka.com.cn');
        // 跳转到绑定页
        location.href = DATA.bind;
    };
    newBind(url);
};
